import { VIEW_PATHS } from './navigation'

export const preserveAffiliateCheckoutSearch = (search: string | null | undefined) => {
  const normalizedSearch = String(search ?? '')
  return new URLSearchParams(normalizedSearch).get('afiliado')?.trim() ? normalizedSearch : ''
}

export const buildAffiliateCheckoutLink = (
  origin: string,
  productId: number,
  affiliateCode: string,
) => {
  const url = new URL(VIEW_PATHS['quick-checkout'], origin)
  url.searchParams.set('produto_id', String(productId))
  url.searchParams.set('quantidade', '1')
  url.searchParams.set('afiliado', affiliateCode)
  return url.toString()
}

export const buildAffiliateCartCheckoutLink = (origin: string, affiliateCode: string) => {
  const url = new URL(VIEW_PATHS['quick-checkout'], origin)
  url.searchParams.set('afiliado', affiliateCode)
  return url.toString()
}
